import { useCallback, useState } from 'react';

function useInsuredCnpjAiAlert(autofilledFields: string[] | undefined) {
  const [dismissed, setDismissed] = useState(false);

  const showAlert = !dismissed && (autofilledFields || []).includes('insured_cnpj');
  const dismissAlert = useCallback(() => setDismissed(true), []);

  return { showAlert, dismissAlert };
}

export default useInsuredCnpjAiAlert;
